  const global_ = {
    organ_id:161,//正式一中账号
    // organ_id:312,//测试刘大光

    baseUrl:'https://www.qyyz.cn/',//正式网址 
    // baseUrl:'http://qyoneschool.jsytest.top/',//测试网址

    // --正式文章id
    // articleId_xinxiChaxun:'574',//学生信息查询 article_id
    // articleId_fenbanChaxun:'575',//高一新生分班信息查询 article_id
    // articleId_xiaoyou:'668',//校友信息查询与登记平台 article_id
    // articleId_xinxiWanshan:'669',//学生信息完善 article_id
    

    // --测试文章id
    articleId_xinxiChaxun:'574',//学生信息查询 article_id
    articleId_fenbanChaxun:'672',//高一新生分班信息查询 article_id
    articleId_xiaoyou:'668',//校友信息查询与登记平台 article_id
    articleId_xinxiWanshan:'669',//学生信息完善 article_id
  }
  export default global_